<script setup lang="ts">
import { toRefs } from 'vue';

interface StepInterface {
  title: string;
  id: number;
}

interface PropsInterface {
  className: string;
  step: StepInterface;
}

const props = defineProps<PropsInterface>();
const { className, step } = toRefs(props);
</script>

<template>
  <div class="flex justify-content-center align-items-center flex-column step" :class="className">
    <div
      class="border-circle bg-white text-gray-900 font-bold flex align-items-center justify-content-center round-container"
    >
      {{ step.id + 1 }}
    </div>
    <label class="font-bold" v-text="step.title" />
  </div>
</template>

<style scoped lang="scss">
.step {
  z-index: 10;

  .round-container {
    margin-bottom: 7px;
    width: 24px;
    height: 24px;
    border: 2px solid white;
  }

  &.selected {
    .round-container {
      background-color: var(--primary-100) !important;
      color: var(--primary-500) !important;
    }
    label {
      font-size: 14px;
      line-height: 18px;
      color: var(--primary-700);
    }
  }
}
</style>
